
    
<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "contentAwait",
  components: {
    ContentLoader
  }
};
</script>

<template>
  <div id="content">
    <content-loader
      :height="80"
      :width="400"
      :speed="3"
      primaryColor="#D7D9DB"
      secondaryColor="#868E92"
    >
      <circle cx="96" cy="110" r="30" />
      <circle cx="151" cy="49" r="1" />
      <rect x="311" y="15" rx="0" ry="0" width="79" height="51" />
      <rect x="108" y="17" rx="0" ry="0" width="82" height="15" />
      <rect x="127" y="42" rx="0" ry="0" width="141" height="7" />
      <circle cx="48" cy="41" r="26" />
      <rect x="205" y="17" rx="0" ry="0" width="82" height="15" />
      <rect x="128" y="59" rx="0" ry="0" width="141" height="7" />
    </content-loader>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#content {
  background: $light;
  cursor: pointer;
  padding: 1em 1.5em;
  box-shadow: 0 1px 3px 0 rgba(32, 33, 36, 0.28);
  border-radius: 0.375rem;
  border-color: $primary-dark;
  border-width: 0.2px;
  min-height: 80px;
}
</style>